export const PACKS_PAGE = 'packs_page';
export const PACK_DETAILS_PAGE = 'pack_details_page';
export const PACK_ACCEPT_PAGE = 'pack_accept_page';

// The chat-dispatch messages the packs surfaces hand to chatHandoffLink. Pack edits are a
// chat capability (the agent owns the pack files), so every mutation CTA drops the user
// into chat with an explicit, addressable request — `packs/<slug>` names the pack's VFS
// folder so the agent resolves the right one. Deliberately not localized: they are
// agent-facing dispatches, like the pulses "create" handoff.
export const packChatMessages = {
  create: () => `Let's create a Symphony pack.`,
  edit: (name: string, slug: string) => `Let's edit my "${name}" pack (packs/${slug}).`,
  changeItem: (itemName: string, packName: string, slug: string) =>
    `Let's change "${itemName}" in my "${packName}" pack (packs/${slug}).`,
  removeItem: (itemName: string, packName: string, slug: string) =>
    `Remove "${itemName}" from my "${packName}" pack (packs/${slug}).`,
  fixValidation: (name: string, slug: string, error: string) =>
    `Sharing my "${name}" pack (packs/${slug}) failed validation: ${error} — let's fix it.`,
  fixDashboardRef: (name: string, slug: string, ref: string) =>
    `In my "${name}" pack (packs/${slug}), the dashboard reference ${ref} doesn't resolve — let's fix it.`,
};
